import { render, staticRenderFns } from "./znsp.vue?vue&type=template&id=9b0d0a62&scoped=true"
import script from "./znsp.vue?vue&type=script&lang=js"
export * from "./znsp.vue?vue&type=script&lang=js"
import style0 from "./znsp.vue?vue&type=style&index=0&id=9b0d0a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0d0a62",
  null
  
)

export default component.exports